$(window).on('load',function () {
	new Swiper('.js-center-slide', {
		centeredSlides: false,
		autoHeight: true,
		slidesPerView: 1,
		loop: true,
		spaceBetween: 0,
		navigation: {
			nextEl: '.js-prev',
			prevEl: '.js-next',
		},
		breakpoints: {
			481: {
    			slidesPerView: 3,
    			autoHeight: false,
    			spaceBetween: 50,
    			centeredSlides: true
    		},
		}
	});

	new Swiper('.js-example', {
		centeredSlides: false,
		slidesPerView: 'auto',
		loop: false,
		autoHeight: true,
		spaceBetween: 10,
		navigation: {
			nextEl: '.js-prev-2',
			prevEl: '.js-next-2',
		}
	});
});

$(function(){

	var promoSlider = $('.js-promo-slider');
	var pagination = $('.js-pagination');
	var navPrev = $('.promo-slider__nav .prev')
	var navNext = $('.promo-slider__nav .next');
	var navCtrl = $('.promo-slider__nav .js-nav-ctrl');
	var activeSlideIndex = 0;
	var slideTransitionDelay = 1000;

	// if (isWidth(560, true)) slideTransitionDelay = 16650;

	promoSlider.on('init', function (event, slick) {
		promoSlider.addClass('_anim');
		setTimeout(function() { promoSlider.addClass('_anim-later') }, 300);

		for (var i = 0; i < slick.slideCount; i++) {
			pagination.append('<li class="slider-pagination" data-action="dot" data-index="'+i+'">0'+[i+1]+'</li>')
		}

		calcPosition();
	});

	function updateDotClass() {
		pagination.find('li').removeClass('active');
		pagination.find('[data-index='+activeSlideIndex+']').addClass('active');
	};

	promoSlider.slick({
		arrows: false,
		draggable: false,
		touchMove: false,
		swipe: false,
		// adaptiveHeight: true,
		speed: 0,
		fade: true,
		autoplay: false
	});

	var autoSlideChange = null;
	var autoSlideChangeTime = 6000;
	var _startTimeOut;
	initSlideInterval();

	function initSlideInterval(){
		autoSlideChange = setInterval(function(){
			navNext.trigger('click')
		}, autoSlideChangeTime);
	}

	function deleteSlideInterval(){
		clearInterval(autoSlideChange);
		autoSlideChange = 0;
		if (typeof _startTimeOut !== 'undefined') {
			clearTimeout(_startTimeOut)
		}
		_startTimeOut = setTimeout(function () {
			initSlideInterval();
		}, autoSlideChangeTime);
	}

	pagination.find('[data-index=' + activeSlideIndex + ']').addClass('active');

	pagination.find('li').click(function(){
		deleteSlideInterval();
		var slideIndex = $(this).data('index');
		var act = $(this).data('action');
		pagination.find('li').removeClass('active');
		$(this).addClass('active');
		transitionSlide(act, slideIndex);
	})

	navCtrl.click(function(e) {
		if (e.originalEvent !== undefined){
			deleteSlideInterval();
		}
		var act = $(this).data('action');
		transitionSlide(act);
	});

	function transitionSlide(action, index){

		promoSlider.removeClass('_anim _anim-later');
		setTimeout(function () {
			if (action === 'next'){
				promoSlider.slick('slickNext');
				activeSlideIndex = promoSlider.slick('slickCurrentSlide');
			}
			if (action === 'prev'){
				promoSlider.slick('slickPrev');
				activeSlideIndex = promoSlider.slick('slickCurrentSlide');
			}
			if (action == 'dot'){
				promoSlider.slick('slickGoTo', index);
				activeSlideIndex = index;
			}
			calcPosition();
			promoSlider.addClass('_anim');
			updateDotClass();
		}, slideTransitionDelay);
		setTimeout(function () {
			promoSlider.addClass('_anim-later')
		}, slideTransitionDelay + 400);

	}

	function calcPosition(){
		if (isWidth(800, true)){
			var height = $('.slick-active .promo-img').outerHeight() +
				$('.slick-active .promo-slide__type').outerHeight(true) +
				parseInt($('.slick-active .promo-content').css('padding-top'));

			pagination.css('top', height + 5);
		}
	}

	$(window).resize(calcPosition);

	/* ** person slider  **** */

	var personSlider = $('.js-person-slider');

	personSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
		personSlider.find('.plyr.plyr--playing').each(function (id, player) {
			if ( !$(player).parents('.slick-slide').hasClass('slick-active') ) {
				$(player).find('.plyr__video-embed').trigger('click')
			}
		})
	});

	personSlider.slick({
		arrows: false,
		centerMode: true,
		slidesToShow: 3,
		centerPadding: '0',
		speed: 700,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});


	$('.person-slider__nav .prev').click(function(){
		personSlider.slick('slickPrev');
	})
	$('.person-slider__nav .next').click(function () {
		personSlider.slick('slickNext');
	})

	/* ** client slider  **** */

	var clientSlider = $('.js-person-client__slider');
	var length = $('.person-client__item').length

	function initClientSlider(){
		clientSlider.slick({
			arrows: false,
			speed: 700,
			slidesToShow: 10,
			slidesToScroll: 4,
			responsive: [{
				breakpoint: 1100,
				settings: {
					slidesToShow: 8,
					slidesToScroll: 3
				}
			},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 5
					}
				}
			]
		});
		$('.person-client__nav').click(function () {
			clientSlider.slick('slickNext');
		});
	}

	if ( $W.width() > 1100 && length > 10) {
		initClientSlider();
	}
	else if ($W.width() < 1100 && $W.width() > 480 && length > 8) {
		initClientSlider();
	}
	else if ($W.width() < 480 && length > 5) {
		initClientSlider();
	}


});
